import { ParsedQs } from 'qs';

/**
 * This function is born out of fixing bad request parameters sent by our clients.
 * The clients have been sending duplicated request parameters, which Express treats as a string[] rather than a string.
 *
 * ex. ?param1=true&param1=duplicated
 * Result: req.param['param1'] = [ 'true', 'duplicated' ]
 *
 * This function is a helper that checks that some evaluationCallback is true for the single string case or the array case.
 *
 * @param requestParameter
 * @param evaluateCallback
 */
export function solveMultiValueParameter(
    requestParameter: any,
    evaluateCallback: (parameterValue: string) => boolean,
): string | undefined {
    if (typeof requestParameter === 'string') {
        if (evaluateCallback(requestParameter.toLowerCase())) {
            return requestParameter.toLowerCase();
        }
    } else if (Array.isArray(requestParameter)) {
        const parameterValues = requestParameter as string[];
        return parameterValues
            .find((paramValue: string) => {
                return evaluateCallback(paramValue.toLowerCase());
            })
            ?.toLowerCase();
    }
    return undefined;
}

/* Simple helper to merge a path with query params */
export function buildUrl(path: string, params: URLSearchParams): string {
    const joinChar = path.includes('?') ? '&' : '?';
    return path + joinChar + params.toString();
}

export function isTruthy(value: undefined | boolean | string | ParsedQs | (string | ParsedQs)[]) {
    if (typeof value === 'string') {
        return value === 'true';
    }
    if (typeof value === 'boolean') {
        return value;
    }
    return false;
}
